module.exports = __webpack_public_path__ + "img/Lucky_Sep_2024.d3241ef6.jpg";